var _path, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRejectSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1893 8.38307C15.4435 7.78344 15.6323 7.15426 15.6812 6.43934C15.8023 4.64517 14.6542 2.90292 12.8542 2.49332C12.56 2.42986 12.2658 2.39524 11.9773 2.40101C9.97539 2.42409 8.30808 4.07404 8.30808 6.0932C8.30808 7.51342 8.88224 8.60556 9.47978 9.74218C9.55459 9.88448 9.62977 10.0275 9.70424 10.1719C9.75616 10.27 9.78501 10.3969 9.78501 10.5123V12.7391H9.68116L4.13693 14.2679C3.12731 14.4929 2.40039 15.3987 2.40039 16.4313V18.6466H3.87731V19.3851C3.87731 19.4836 3.88385 19.5806 3.89651 19.6758L15.1893 8.38307ZM5.05867 21.3421C5.3679 21.5068 5.72003 21.6004 6.0927 21.6004H17.9081C19.1254 21.6004 20.1235 20.6023 20.1235 19.3851V18.6466H21.6004V16.4313C21.6004 15.3987 20.8735 14.4929 19.8639 14.2679L14.3196 12.7391H14.2158V12.185L7.75414 18.6466H18.6465V19.3851C18.6465 19.8004 18.3235 20.1235 17.9081 20.1235H6.27727L5.05867 21.3421Z",
    fill: "#767B87"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2.40817,
    y1: 22.4472,
    x2: 21.0758,
    y2: 3.77961,
    stroke: "#767B87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectSolid);
export default __webpack_public_path__ + "static/media/reject_solid.f2556aaf931d46307a5a87874cd83b18.svg";
export { ForwardRef as ReactComponent };